import { Heading, Paragraph } from "@/components/ui/Typography";
import type { MicroSite } from "@/lib/api";
import { sanitizeHtml } from "@/utils/helpers/html";


const Hero = ({data}:{data: MicroSite}) => {

  if(!data){
    return null;
  };

  const PreviewComponent = () => {
    return (
      <div className=" relative flex flex-col  w-full min-h-96 xl:min-h-[35rem]">

        <div className="flex p-1 items-center justify-center">
            <img src={data?.branding?.websiteLogoUrl} alt="" className="h-12 object-contain w-fit min-w-fit" />
        </div>
         <img src={data?.headerSection?.headerImageUrl ?? "/blank-image-placeholder.png"} alt={"Hero Section"} className="w-full object-cover min-h-[30rem] object-center" />
        <div className="h-full flex items-center justify-center relative">
             

       {/* Title and description */}
        <div className="grid md:grid-cols-2 items-center justify-center  gap-4 w-full lg:gap-16 p-4 lg:p-16">
        
          <div className="flex items-center gap-3">
          <Heading level={1} className="" >{data?.headerSection?.headerTitle}</Heading>

          </div>
          <Paragraph className=""  dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.headerSection?.headerDescription ?? "") }} ></Paragraph>
        </div>
        </div>
           
      </div>
    )
  };




  return (
    <div>
       <PreviewComponent />
    </div>
  )
}

export default Hero